import { v4 as uuidv4 } from 'uuid';
import { MarketingEventsPlanDepartmentsGrid } from './MarketingEventsPlanDepartmentsGrid';
import i18n from '../../../../i18n';
import { MarketingEventsPlanDepartmentsGridPluginSettings } from './MarketingEventsPlanDepartmentsGridPluginSettings';

export const MarketingEventsPlanDepartmentsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingEventsPlanDepartments"),
        view: {
            content: MarketingEventsPlanDepartmentsGridPluginSettings
                ? <MarketingEventsPlanDepartmentsGrid gridId={uuidv4()} plugin={MarketingEventsPlanDepartmentsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
